import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventActionLayoutRoute() {
  return <ModalStack />;
}
